module.exports = __webpack_public_path__ + "static/media/unk.c6611ace.png";